// extracted by mini-css-extract-plugin
export var modalOverlay = "FormModal-module--modalOverlay--E1etQ";
export var modal = "FormModal-module--modal--77RtJ";
export var fadeIn = "FormModal-module--fadeIn--91Rrb";
export var slideIn = "FormModal-module--slideIn--ymVFX";
export var modalCloseButton = "FormModal-module--modalCloseButton--lSEDV";
export var formInput = "FormModal-module--formInput--9OeSa";
export var formContainer = "FormModal-module--formContainer--GJry-";
export var buttonContainer = "FormModal-module--buttonContainer--rbOvw";
export var noWidth = "FormModal-module--noWidth--xPLkw";
export var spinnerModal = "FormModal-module--spinnerModal--tVFNu";
export var spinner = "FormModal-module--spinner--QTWbU";
export var spin = "FormModal-module--spin--zKdKT";